exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-stage {\n}\n\n.loading-bar {\n  height:52px;\n  color:white;\n  padding:0px 8px;\n  line-height:52px;\n  font-size:1.5rem;\n  text-align:right;\n  background:#009688;\n  transition:0.5s width cubic-bezier(.35, 0, .25, 1);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.css
// module id = 215
// module chunks = 1